// Dynamic Yield
export const sendCartToDy = (cartItems) => {
  window.DY.API("event", {
    name: "Add to Cart",
    properties: {
      dyType: "add-to-cart-v1",
      value: cartItems[0]?.itemPrice || "",
      productId: cartItems[0]?.productId || "",
      quantity: cartItems[0]?.quantity || "",
      cart: cartItems,
    },
  });
};
